module.exports = __webpack_public_path__ + "static/media/referez_ami_nouveau.0ae068f7.png";